import { render, staticRenderFns } from "./patent-Interest.vue?vue&type=template&id=699417b9&scoped=true&"
import script from "./patent-Interest.vue?vue&type=script&lang=js&"
export * from "./patent-Interest.vue?vue&type=script&lang=js&"
import style0 from "./patent-Interest.vue?vue&type=style&index=0&id=699417b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699417b9",
  null
  
)

export default component.exports